import React, { useContext } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { LockContext } from '../../context/LockContext';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import { useAuth } from '../../context/AuthContext';
import { openAlert } from '../../utils/common';
import { CALIBRATION_ACCESS_ROLES } from '../../utils/calibrationAdmin';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { role, isLoading, logout } = useAuth();
  const { lock } = useContext(LockContext);

  const links = [
    { to: '/settings', label: '기본설정', roles: ['super_admin', 'admin', 'manager', 'operator'] },
    { to: '/account', label: '회원조회', roles: ['super_admin', 'admin', 'manager', 'operator'] },
    { to: '/bluetooth', label: '블루투스', roles: ['super_admin', 'admin', 'manager', 'operator'] },
    { to: '/glucodata', label: '혈당 측정 데이터', roles: ['super_admin', 'admin', 'manager', 'operator'] },
    { to: '/report', label: '보고서 작성', roles: ['super_admin', 'admin', 'manager', 'operator'] },
    { to: '/calibration', label: '보정 관리', roles: CALIBRATION_ACCESS_ROLES },
    { to: '/system', label: '시스템 관리', roles: ['super_admin'] },
  ];

  if (isLoading) return null;

  const visibleLinks = role === 'calibration_operator'
    ? links.filter((link) => link.to === '/calibration')
    : links.filter((link) => !link.roles || link.roles.includes(role));

  const handleLogout = async () => {
    try {
      const success = await logout();
      if (success) {
        navigate('/login', { replace: true });
      } else {
        openAlert({ title: '알림', description: '로그아웃에 실패했습니다.' });
      }
    } catch (error) {
      console.error(error);
      openAlert({ title: '알림', description: '로그아웃 중 오류가 발생했습니다.' });
    }
  };

  const isActive = (linkPath) => (
    location.pathname === linkPath || location.pathname.startsWith(`${linkPath}/`)
  );

  return (
    <header className="adm_header">
      <div className="utill">
        <span className="lock-link" onClick={lock} style={{ cursor: 'pointer', marginRight: '1rem' }}>잠금 화면</span>
        <span className="logout-link" onClick={handleLogout}>로그아웃</span>
      </div>
      <div className="category">
        <ul className="gnb">
          {visibleLinks.map((link) => (
            <li key={link.to} className={isActive(link.to) ? 'current' : ''}>
              <NavLink to={link.to}>
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default Header;
